import { TemplatePlaceholderWithFilterContext } from '@/types';

export function countAllPlaceholders(obj: unknown) {
  if (obj === undefined) {
    return 0;
  }
  if (obj === null) {
    return 0;
  }
  let numPlaceHolders = 0;
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      const objAsArray = obj as unknown[];
      for (const objEntry of objAsArray) {
        numPlaceHolders += countAllPlaceholders(objEntry);
      }
    } else {
      const objAsObject = obj as {
        [s: string]: unknown;
      };
      for (const [key, value] of Object.entries(objAsObject)) {
        if (key === 'placeholder') {
          numPlaceHolders += 1;
        }
        numPlaceHolders += countAllPlaceholders(value);
      }
    }
    return numPlaceHolders;
  } else {
    return 0;
  }
}

export function hasNotRenewing(obj: unknown) {
  if (obj === undefined) {
    return false;
  }
  if (obj === null) {
    return false;
  }
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      const objAsArray = obj as unknown[];
      for (const objEntry of objAsArray) {
        if (hasNotRenewing(objEntry)) {
          return true;
        }
      }
      return false;
    } else {
      const objAsObject = obj as {
        [s: string]: unknown;
      };
      for (const [key, value] of Object.entries(objAsObject)) {
        if (key === 'notRenewing' && value) {
          return true;
        }
        if (hasNotRenewing(value)) {
          return true;
        }
      }
      return false;
    }
  } else {
    return false;
  }
}

export function isRosterElectionPlaceHolder(obj: { [s: string]: unknown }) {
  if (obj.name !== 'roster') {
    return false;
  }
  if (!obj.value) {
    return false;
  }
  if (typeof obj.value !== 'object') {
    return false;
  }
  if (Array.isArray(obj.value)) {
    return false;
  }
  const objValue = obj.value as {
    [s: string]: unknown;
  };
  if (!objValue.electionId) {
    return false;
  }
  if (typeof objValue.electionId !== 'object') {
    return false;
  }
  if (Array.isArray(objValue.electionId)) {
    return false;
  }
  const electionIdObj = objValue.electionId as {
    [s: string]: unknown;
  };
  if (electionIdObj.placeholder) {
    return true;
  }

  return false;
}

export function countRosterElectionPlaceholders(searchTree: unknown) {
  if (searchTree === undefined) {
    return 0;
  }
  if (searchTree === null) {
    return 0;
  }
  let numPlaceHolders = 0;
  if (typeof searchTree === 'object') {
    if (Array.isArray(searchTree)) {
      const objAsArray = searchTree as unknown[];
      for (const objEntry of objAsArray) {
        numPlaceHolders += countRosterElectionPlaceholders(objEntry);
      }
    } else {
      const objAsObject = searchTree as {
        [s: string]: unknown;
      };
      if (isRosterElectionPlaceHolder(objAsObject)) {
        numPlaceHolders += 1;
      } else {
        for (const value of Object.values(objAsObject)) {
          numPlaceHolders += countRosterElectionPlaceholders(value);
        }
      }
    }
    return numPlaceHolders;
  } else {
    return 0;
  }
}

export function compareElectionPlaceholders(currentSearchTree: unknown, newSearchTree: unknown) {
  return (
    countRosterElectionPlaceholders(currentSearchTree) <
    countRosterElectionPlaceholders(newSearchTree)
  );
}

export function sortPlaceholdersByPosition<T extends TemplatePlaceholderWithFilterContext>(
  placeholders: T[]
) {
  return placeholders.toSorted((a, b) => {
    const posA = a.placeholder.position;
    const posB = b.placeholder.position;

    if (posA === undefined && posB === undefined) return 0;

    if (posA === undefined) return 1;
    if (posB === undefined) return -1;

    return posA - posB;
  });
}
